export default __webpack_public_path__ + "static/serti-fama-7c7626d52e872110f016a8271ec7d0b9.png";